import { type ProcessType } from '@frontend/api';

import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_PROCESSES_ERROR: 'common/processSelector/FETCH_PROCESSES_ERROR',
  FETCH_PROCESSES_REQUEST: 'common/processSelector/FETCH_PROCESSES_REQUEST',
  FETCH_PROCESSES_SUCCESS: 'common/processSelector/FETCH_PROCESSES_SUCCESS',
} as const;

export const fetchProcesses = {
  request: () => ({
    type: types.FETCH_PROCESSES_REQUEST,
  }),
  success: ({ processes }: { processes: ProcessType[] }) => ({
    type: types.FETCH_PROCESSES_SUCCESS,
    payload: { processes },
  }),
  error: notify(
    (error) => ({
      type: types.FETCH_PROCESSES_ERROR,
      payload: error,
    }),
    "Can't fetch processes",
  ),
};
